import { useEffect } from 'react'
import { useSearchParams } from '@/router/navigation'
import type { DocuSignReturnMessage } from '../docusign/DocuSignReturnMessage'

export function SignatureReturnPage() {
  const [searchParams] = useSearchParams()
  const returnEvent = searchParams.get('event') ?? ''

  useEffect(() => {
    if (window.parent === window) return

    const message: DocuSignReturnMessage = {
      type: 'DOCUSIGN_RETURN',
      event: returnEvent
    }

    window.parent.postMessage(message, '*')
  }, [returnEvent])

  return (
    <div className="mx-auto max-w-2xl px-4 py-16 text-center">
      <h1 className="text-xl font-semibold text-gray-800">Verifying Your Signature</h1>
      <p className="mt-3 text-sm text-gray-500">
        Please wait while we confirm your documents have been signed.
      </p>
    </div>
  )
}
